import makeStyles from "@mui/styles/makeStyles";
import { FontFamilySwitch } from "../../../utils";

export const componantsStyles = makeStyles((theme) => ({
    img: {
        objectFit: "cover",
        height: "54px",
        width: "54px",
        borderRadius: "10px"
    },
    profileimg: {
        backgroundColor: theme.palette.background.tertiary,
        color: "#E4E8EE",
        position: "relative",
    },
    profileicon: {
        fontSize: "80px",
        padding: "14px",
    },
    profileimgs: {
        backgroundColor: theme.palette.background.tertiary,
        color: "#E4E8EE",
        position: "absolute",
        bottom: "0px",
        right: "0px",
        border: "2px solid white",
        borderRadius: "50%",
    },

    profilesection: {
        marginTop: "14px",

    },
    imgDiv: {
        position: "relative",
        width: "90px"
    },
    close: {
        position: "absolute",
        top: "0px",
        right: "0px",
        backgroundColor: "red",
        "&:hover": {
            backgroundColor: "red",
        },
    },
    title: {
        fontSize:"0.75rem",
        fontFamily: FontFamilySwitch().bold,
        textTransform: "uppercase",
        marginBottom: "12px"
    },
    createTitle: {
        fontSize:"0.875rem",
        fontFamily: FontFamilySwitch().extraBold,
        marginBottom: "12px",
        color: "#4E5A6B"
    },
    btn: {
        border: "1px solid #CED3DD",
        color: "#091B29",
        fontFamily: FontFamilySwitch().bold,
        fontSize:"0.875rem",
        backgroundColor: "white ",
        "&:hover": {
            backgroundColor: "white ",
        },
    },
    sumbitBtn: {
        fontFamily: FontFamilySwitch().bold,
        fontSize:"0.875rem",
    }

}));